module.exports = {"Warn":"警告する","Error":"エラー","Critical":"クリティカルな","Ok":"はい"}


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle/message-jp.json
// module id = ZqSJ
// module chunks = 15